import { generateQuery } from './queryTemplates';

// Helper to generate multiple queries of a specific status
// Prioritize non-seoplus+ experts to show company diversity
const generateBatch = (
  startId,
  count,
  status,
  expertIDs = [
    // seoplus+ experts
    60, 106,
    // New diverse companies (14 experts)
    301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314,
  ]
) => {
  const queries = [];
  for (let i = 0; i < count; i++) {
    const id = startId + i;
    const topicIndex = i % 15;
    const expertID = status !== 'new' && status !== 'discarded' ? expertIDs[i % expertIDs.length] : undefined;
    queries.push(generateQuery(id, topicIndex, status, expertID ? { expertID } : {}));
  }
  return queries;
};

// Generate queries for different statuses
const generatedQueries = [
  // NEW queries (for Queries tab) - IDs 1-150
  ...generateBatch(1, 150, 'new'),

  // DRAFT/INBOX queries - IDs 151-300
  ...generateBatch(151, 2, 'draft'),
  ...generateBatch(176, 4, 'awaiting'),
  ...generateBatch(201, 25, 'claimed'),
  ...generateBatch(226, 0, 'clientApproved'),
  ...generateBatch(251, 6, 'needsFollowUp'),
  ...generateBatch(276, 0, 'clientNeedsEdits'),

  // SUBMITTED/PENDING queries - IDs 301-420
  ...generateBatch(301, 60, 'pending'),
  ...generateBatch(361, 30, 'pendingPublication'),
  ...generateBatch(391, 30, 'paidEditorial'),

  // SUCCESSFUL - IDs 421-480
  ...generateBatch(421, 60, 'successful'),

  // REPURPOSE queries - IDs 481-580
  ...generateBatch(481, 25, 'repurposed'),
  ...generateBatch(506, 25, 'journalistPassed'),
  ...generateBatch(531, 25, 'clientPassed'),
  ...generateBatch(556, 25, 'insightsNotIncluded'),

  // DISCARDED - IDs 581-630
  ...generateBatch(581, 50, 'discarded'),
];

// Override specific queries with custom content for better demo experience
export const DEMO_QUERIES = generatedQueries.map((query) => {
  // Override query 201 (claimed) with detailed pitch
  if (query.id === 201) {
    return {
      ...query,
      userClaimID: 1, // Ensure demo user can see this
      title: 'Social Media Strategy Expert for Tech Startups',
      description:
        'Seeking insights from a social media strategist who has worked with tech startups. Article will focus on building brand presence on emerging platforms.',
      topics: '["Social Media", "Tech Startups", "Brand Strategy"]',
      qwotedTags: [{ hashtag: '#SocialMedia' }, { hashtag: '#TechStartups' }, { hashtag: '#BrandStrategy' }],
      mediaOutlet: 'TechCrunch',
      leads: [
        {
          ...query.leads[0],
          initialSendToExpert: `Hi Brock,

Happy Monday! I came across an opportunity this morning with TechCrunch regarding social media strategy for tech startups. Given your extensive experience as Co-Founder of seoplus+ and your work with various tech companies, I thought this would be a perfect fit. I've drafted some responses below, but feel free to edit as needed or add any additional insights!

The deadline for this opportunity is Friday, November 8th at 5:00 PM EST.
------------------------------------------------
Please share your expert insights on building effective social media presence for tech startups on emerging platforms.

What are the top 3-5 social media platforms tech startups should focus on in 2026, and why?

TikTok and Instagram Reels:
Short-form video content continues to dominate, and tech startups can leverage these platforms to showcase product demos, team culture, and thought leadership in creative ways. The algorithm favors authentic, educational content which aligns perfectly with tech companies wanting to build trust with their audience.

LinkedIn:
Essential for B2B tech startups. It's where decision-makers are actively looking for solutions. Consistent posting of industry insights, company updates, and thought leadership content helps establish credibility and generate qualified leads.

Twitter/X:
Still highly relevant for tech industry discussions, product launches, and real-time engagement with your community. Tech journalists and influencers are particularly active here, making it invaluable for PR opportunities.

Please share 3 common mistakes tech startups make with their social media strategy:

Inconsistent posting schedule:
Many startups post frequently at launch but then go silent for weeks. Consistency builds audience trust and helps with algorithm performance. Solution: Create a content calendar and batch-create content monthly.

Overly promotional content:
Constantly selling kills engagement. The 80/20 rule applies - 80% educational/entertaining content, 20% promotional. Share industry insights, tips, and behind-the-scenes content to build genuine connections.

Ignoring community engagement:
Posting without responding to comments or engaging with others' content. Social media is a two-way conversation. Dedicate 15-30 minutes daily to respond to comments and engage with your industry community.

What metrics should tech startups track to measure social media success?

Focus on engagement rate over follower count, click-through rates to your website, lead generation from social channels, and community growth rate. These metrics tie directly to business goals rather than vanity metrics.
------------------------------------------------
Query: Social Media Strategy Expert for Tech Startups
Outlet: TechCrunch
Deadline: Friday, November 8th at 5:00 PM EST
------------------------------------------------
Let me know if you'd like to add or adjust anything!

Best regards,
Catherine`,
          currentSendToExpert: `Hi Brock,

Happy Monday! I came across an opportunity this morning with TechCrunch regarding social media strategy for tech startups. Given your extensive experience as Co-Founder of seoplus+ and your work with various tech companies, I thought this would be a perfect fit. I've drafted some responses below, but feel free to edit as needed or add any additional insights!

The deadline for this opportunity is Friday, November 8th at 5:00 PM EST.
------------------------------------------------
Please share your expert insights on building effective social media presence for tech startups on emerging platforms.

What are the top 3-5 social media platforms tech startups should focus on in 2026, and why?

TikTok and Instagram Reels:
Short-form video content continues to dominate, and tech startups can leverage these platforms to showcase product demos, team culture, and thought leadership in creative ways. The algorithm favors authentic, educational content which aligns perfectly with tech companies wanting to build trust with their audience.

LinkedIn:
Essential for B2B tech startups. It's where decision-makers are actively looking for solutions. Consistent posting of industry insights, company updates, and thought leadership content helps establish credibility and generate qualified leads.

Twitter/X:
Still highly relevant for tech industry discussions, product launches, and real-time engagement with your community. Tech journalists and influencers are particularly active here, making it invaluable for PR opportunities.

Please share 3 common mistakes tech startups make with their social media strategy:

Inconsistent posting schedule:
Many startups post frequently at launch but then go silent for weeks. Consistency builds audience trust and helps with algorithm performance. Solution: Create a content calendar and batch-create content monthly.

Overly promotional content:
Constantly selling kills engagement. The 80/20 rule applies - 80% educational/entertaining content, 20% promotional. Share industry insights, tips, and behind-the-scenes content to build genuine connections.

Ignoring community engagement:
Posting without responding to comments or engaging with others' content. Social media is a two-way conversation. Dedicate 15-30 minutes daily to respond to comments and engage with your industry community.

What metrics should tech startups track to measure social media success?

Focus on engagement rate over follower count, click-through rates to your website, lead generation from social channels, and community growth rate. These metrics tie directly to business goals rather than vanity metrics.
------------------------------------------------
Query: Social Media Strategy Expert for Tech Startups
Outlet: TechCrunch
Deadline: Friday, November 8th at 5:00 PM EST
------------------------------------------------
Let me know if you'd like to add or adjust anything!

Best regards,
Catherine`,
        },
      ],
    };
  }

  // Override query 301 (submitted) with detailed content
  if (query.id === 301) {
    return {
      ...query,
      userClaimID: 1,
      title: 'E-commerce SEO Best Practices',
      description:
        'Article on e-commerce SEO optimization. Need expert commentary on technical SEO, product page optimization, and link building strategies for online stores.',
      topics: '["E-commerce", "SEO", "Technical SEO"]',
      qwotedTags: [{ hashtag: '#Ecommerce' }, { hashtag: '#SEO' }, { hashtag: '#TechnicalSEO' }],
      mediaOutlet: 'Search Engine Journal',
      expertsID: 60,
      leads: [
        {
          ...query.leads[0],
          expertID: 60,
          currentQueryText: `Hi Rebecca,

I hope your day is going well!

I am reaching out on behalf of Brock Murray, Co-Founder at seoplus+ (https://brock.enterprises/). Brock Murray is the co-founder of seoplus+ digital marketing agency. As the driving force behind this award-winning, full-service agency, Brock's passion is helping businesses establish, grow, and maintain their online presence. With the help of SEO, PPC, social media, content marketing, and more, Brock and his team help clients of varying sizes and verticals, from small, local retailers to large, multinational enterprise companies.

Brock Murray was happy to offer some insight into your query, as can be seen below:
-----------------------------
As the co-founder of seoplus+ with years of experience helping e-commerce clients grow their online presence, I'd be happy to share insights on best practices for online stores.

Technical SEO is crucial for e-commerce success. Site speed optimization should be a top priority - every second of delay can cost you 7% in conversions. I recommend compressing images, implementing lazy loading, and using a CDN to ensure fast load times across all product pages.

Structured data implementation is another game-changer. By using schema markup for products, reviews, prices, and availability, you can enable rich snippets in search results, which can increase click-through rates by up to 30%. This helps search engines understand your inventory and can trigger valuable Google Shopping features.

For product page optimization, unique content is key. Avoid using manufacturer descriptions that appear on dozens of competitor sites. Instead, write detailed, keyword-rich descriptions that incorporate target keywords naturally. Include specifications, use cases, and benefits. For example, instead of generic descriptions like "Blue running shoes," use descriptive titles like "Lightweight Blue Marathon Running Shoes with Breathable Mesh for Long-Distance Training."

Image optimization is often overlooked but critical. Use descriptive, keyword-rich file names and alt text - this improves both accessibility and image search visibility. Replace generic filenames like "IMG_1234.jpg" with descriptive ones like "blue-marathon-running-shoes-side-view.jpg."

For link building, I recommend focusing on product-specific outreach to relevant bloggers and reviewers, creating data-driven industry reports to earn editorial links, and building partnerships with complementary (non-competing) e-commerce brands. Quality over quantity is essential - one link from a high-authority industry site provides more value than dozens of low-quality directory links.

I'm available for follow-up questions and can provide more specific examples based on the article's focus.

Best regards,
Brock Murray
Co-Founder, seoplus+
-----------------------------
Let me know if you have any additional questions, Brock Murray is always happy to help!

Thank you very much for your time,

Catherine`,
          initialSendToExpert: `Hi Brock,

Good morning! I found a great opportunity with Search Engine Journal about e-commerce SEO optimization. With your extensive experience leading seoplus+ and helping e-commerce clients grow, you'd be perfect for this piece. I've prepared some draft responses below - please review and add your expertise!

The deadline for this opportunity is Thursday, November 2nd at 3:00 PM EST.
------------------------------------------------
Article focus: E-commerce SEO Best Practices for Online Stores

Please share 4-5 essential technical SEO practices for e-commerce websites:

Site Speed Optimization:
Page load time directly impacts both rankings and conversions. Compress images, implement lazy loading, and use a CDN. Studies show that a 1-second delay can reduce conversions by 7%. For e-commerce sites with hundreds of products, this is critical.

Structured Data Implementation:
Use schema markup for products, reviews, prices, and availability. This enables rich snippets in search results, increasing click-through rates by up to 30%. Product schema helps search engines understand your inventory and can trigger Google Shopping features.

Mobile-First Optimization:
With over 60% of e-commerce traffic coming from mobile devices, ensure your site is fully responsive. Google's mobile-first indexing means your mobile site determines your rankings. Focus on touch-friendly navigation and fast mobile load times.

XML Sitemap Optimization:
Create separate sitemaps for products, categories, and content pages. Update them dynamically as inventory changes. This helps search engines discover and index new products quickly.

Please discuss product page optimization strategies with specific examples:

Unique Product Descriptions:
Avoid manufacturer descriptions that appear on dozens of other sites. Write unique, detailed descriptions that incorporate target keywords naturally. Include specifications, use cases, and benefits. For example, instead of "Blue running shoes," use "Lightweight Blue Marathon Running Shoes with Breathable Mesh for Long-Distance Training."

Image Optimization:
Use descriptive, keyword-rich file names and alt text. Instead of "IMG_1234.jpg," use "blue-marathon-running-shoes-side-view.jpg." This improves both accessibility and image search visibility.

User-Generated Content:
Encourage customer reviews and Q&A sections. This adds fresh, unique content to product pages and naturally incorporates long-tail keywords that customers actually search for.

What are your top recommendations for e-commerce link building?

Focus on product-specific outreach to relevant bloggers and reviewers, create data-driven industry reports to earn editorial links, leverage supplier and manufacturer relationships for brand mentions, and build partnerships with complementary (non-competing) e-commerce brands. Quality over quantity is key - one link from a high-authority industry site is worth more than dozens of low-quality directory links.
------------------------------------------------
Query: E-commerce SEO Best Practices
Outlet: Search Engine Journal
Deadline: Thursday, November 2nd at 3:00 PM EST
------------------------------------------------
Looking forward to your thoughts!

Best,
Catherine`,
          currentSendToExpert: `Hi Brock,

Good morning! I found a great opportunity with Search Engine Journal about e-commerce SEO optimization. With your extensive experience leading seoplus+ and helping e-commerce clients grow, you'd be perfect for this piece. I've prepared some draft responses below - please review and add your expertise!

The deadline for this opportunity is Thursday, November 2nd at 3:00 PM EST.
------------------------------------------------
Article focus: E-commerce SEO Best Practices for Online Stores

Please share 4-5 essential technical SEO practices for e-commerce websites:

Site Speed Optimization:
Page load time directly impacts both rankings and conversions. Compress images, implement lazy loading, and use a CDN. Studies show that a 1-second delay can reduce conversions by 7%. For e-commerce sites with hundreds of products, this is critical.

Structured Data Implementation:
Use schema markup for products, reviews, prices, and availability. This enables rich snippets in search results, increasing click-through rates by up to 30%. Product schema helps search engines understand your inventory and can trigger Google Shopping features.

Mobile-First Optimization:
With over 60% of e-commerce traffic coming from mobile devices, ensure your site is fully responsive. Google's mobile-first indexing means your mobile site determines your rankings. Focus on touch-friendly navigation and fast mobile load times.

XML Sitemap Optimization:
Create separate sitemaps for products, categories, and content pages. Update them dynamically as inventory changes. This helps search engines discover and index new products quickly.

Please discuss product page optimization strategies with specific examples:

Unique Product Descriptions:
Avoid manufacturer descriptions that appear on dozens of other sites. Write unique, detailed descriptions that incorporate target keywords naturally. Include specifications, use cases, and benefits. For example, instead of "Blue running shoes," use "Lightweight Blue Marathon Running Shoes with Breathable Mesh for Long-Distance Training."

Image Optimization:
Use descriptive, keyword-rich file names and alt text. Instead of "IMG_1234.jpg," use "blue-marathon-running-shoes-side-view.jpg." This improves both accessibility and image search visibility.

User-Generated Content:
Encourage customer reviews and Q&A sections. This adds fresh, unique content to product pages and naturally incorporates long-tail keywords that customers actually search for.

What are your top recommendations for e-commerce link building?

Focus on product-specific outreach to relevant bloggers and reviewers, create data-driven industry reports to earn editorial links, leverage supplier and manufacturer relationships for brand mentions, and build partnerships with complementary (non-competing) e-commerce brands. Quality over quantity is key - one link from a high-authority industry site is worth more than dozens of low-quality directory links.
------------------------------------------------
Query: E-commerce SEO Best Practices
Outlet: Search Engine Journal
Deadline: Thursday, November 2nd at 3:00 PM EST
------------------------------------------------
Looking forward to your thoughts!

Best,
Catherine`,
        },
      ],
    };
  }

  // Override query 421 (successful) with detailed content
  if (query.id === 421) {
    return {
      ...query,
      userClaimID: 1,
      title: 'Remote Work and Team Productivity',
      description:
        'Looking for insights on managing remote teams and maintaining productivity. Focus on digital tools, communication strategies, and work-life balance.',
      topics: '["Remote Work", "Productivity", "Management"]',
      qwotedTags: [{ hashtag: '#RemoteWork' }, { hashtag: '#Productivity' }, { hashtag: '#Management' }],
      mediaOutlet: 'Forbes',
      mediaURL: 'https://forbes.com/remote-work-productivity-2026',
      expertsID: 60,
      leads: [
        {
          ...query.leads[0],
          expertID: 60,
          currentQueryText: `Hi Rebecca,

I hope your week is going well!

I am reaching out on behalf of Brock Murray, Co-Founder at seoplus+ (https://brock.enterprises/). Brock Murray is the co-founder of seoplus+ digital marketing agency. As the driving force behind this award-winning, full-service agency, Brock's passion is helping businesses establish, grow, and maintain their online presence. With the help of SEO, PPC, social media, content marketing, and more, Brock and his team help clients of varying sizes and verticals, from small, local retailers to large, multinational enterprise companies.

Brock Murray was happy to offer some insight into your query, as can be seen below:
-----------------------------
As co-founder of seoplus+ with years of experience building and managing distributed teams, I'm excited to share insights on maintaining productivity in remote work environments.

Communication protocols are foundational to remote team success. At seoplus+, we've defined clear guidelines for which tools to use for different communication types - Slack for quick questions, email for formal communications, and Zoom for face-to-face discussions. We've also implemented "no-meeting Fridays" to give team members dedicated focus time, which has significantly reduced meeting fatigue and increased deep work productivity.

Structured onboarding has been transformative for our remote operations. We create comprehensive documentation, assign mentors to new hires, and schedule regular check-ins during the first 90 days. Since implementing this structured approach, we've seen a 40% improvement in new hire retention and faster time-to-productivity.

For digital tools, project management software like Wrike or Asana is essential. We centralize all project information in one place, create templates for recurring tasks, and use automation for routine processes. This has reduced time spent in status update meetings by 50%, allowing more time for actual work.

Async video tools like Loom have been invaluable for respecting different time zones and work schedules. Recording screen shares and video updates for training, feedback, and project walkthroughs maintains personal connection that text alone can't provide, while giving team members flexibility in when they consume the information.

Work-life balance is critical in remote settings. We encourage team members to set clear boundaries - designated workspace, consistent work hours, and actually taking breaks and vacation time. We've implemented a "right to disconnect" policy where employees aren't expected to respond to non-urgent communications outside their scheduled hours. This has significantly reduced burnout and improved overall team satisfaction.

The key is intentionality - remote work requires more deliberate effort to create the structure and connection that happens naturally in office environments, but when done right, it can actually improve both productivity and employee wellbeing.

Happy to discuss any of these points in more detail!

Best regards,
Brock Murray
Co-Founder, seoplus+
-----------------------------
Let me know if you have any additional questions, Brock Murray is always happy to help!

Thank you very much for your time,

Catherine`,
          initialSendToExpert: `Hi Brock,

I hope you're having a great day! I came across an opportunity with Forbes about managing remote teams and maintaining productivity. As Co-Founder of seoplus+ with years of experience building and leading distributed teams, you're the perfect expert for this piece. I've drafted some responses below based on your experience - please feel free to edit or expand!

The deadline for this opportunity is Wednesday, October 23rd at 2:00 PM EST.
------------------------------------------------
Article focus: Remote Work and Team Productivity in 2026

Please share your top 3-5 strategies for managing remote teams effectively:

Establish Clear Communication Protocols:
Define which tools to use for different types of communication - Slack for quick questions, email for formal communications, Zoom for face-to-face discussions. At seoplus+, we've implemented "no-meeting Fridays" to give team members dedicated focus time. This reduces meeting fatigue and increases deep work productivity.

Implement Structured Onboarding:
Remote onboarding requires extra intentionality. Create comprehensive documentation, assign mentors for new hires, and schedule regular check-ins during the first 90 days. We've seen 40% improvement in new hire retention since implementing our structured remote onboarding program.

Foster Team Culture Virtually:
Schedule regular virtual team building activities and create opportunities for casual conversation. We host monthly virtual coffee chats where team members are randomly paired, and quarterly virtual team events. This helps build relationships beyond work tasks.

Set Clear Expectations and Goals:
Use OKRs (Objectives and Key Results) to align team members with company goals. Remote work requires clarity about expectations, deadlines, and success metrics. Weekly check-ins help keep everyone aligned without micromanaging.

Please discuss 3-4 essential digital tools for remote team productivity and how to use them effectively:

Project Management Software (Wrike/Asana):
Centralize all project information in one place. Create templates for recurring tasks, set up automation for routine processes, and use dashboards for visibility across teams. This reduces time spent in status update meetings by 50%.

Async Video Tools (Loom):
Record screen shares and video updates for training, feedback, and project walkthroughs. This respects different time zones and work schedules while maintaining personal connection that text alone can't provide.

Document Collaboration (Google Workspace/Notion):
Create a single source of truth for all company knowledge. Implement clear naming conventions and folder structures. This reduces time spent searching for information and ensures everyone has access to the latest versions.

Time Zone Management (World Clock/Calendly):
Be mindful of team members across time zones. Schedule meetings during overlapping hours and rotate meeting times if necessary to share the burden. Use async communication when possible to respect work-life boundaries.

What advice would you give about maintaining work-life balance in remote settings?

Encourage team members to set clear boundaries - designated workspace, consistent work hours, and actually taking breaks and vacation time. Lead by example by not sending messages outside work hours. We've implemented a "right to disconnect" policy where employees aren't expected to respond to non-urgent communications outside their scheduled hours. This has significantly reduced burnout and improved overall team satisfaction.
------------------------------------------------
Query: Remote Work and Team Productivity
Outlet: Forbes
Deadline: Wednesday, October 23rd at 2:00 PM EST
------------------------------------------------
Excited to hear your insights on this!

Best regards,
Catherine`,
          currentSendToExpert: `Hi Brock,

I hope you're having a great day! I came across an opportunity with Forbes about managing remote teams and maintaining productivity. As Co-Founder of seoplus+ with years of experience building and leading distributed teams, you're the perfect expert for this piece. I've drafted some responses below based on your experience - please feel free to edit or expand!

The deadline for this opportunity is Wednesday, October 23rd at 2:00 PM EST.
------------------------------------------------
Article focus: Remote Work and Team Productivity in 2026

Please share your top 3-5 strategies for managing remote teams effectively:

Establish Clear Communication Protocols:
Define which tools to use for different types of communication - Slack for quick questions, email for formal communications, Zoom for face-to-face discussions. At seoplus+, we've implemented "no-meeting Fridays" to give team members dedicated focus time. This reduces meeting fatigue and increases deep work productivity.

Implement Structured Onboarding:
Remote onboarding requires extra intentionality. Create comprehensive documentation, assign mentors for new hires, and schedule regular check-ins during the first 90 days. We've seen 40% improvement in new hire retention since implementing our structured remote onboarding program.

Foster Team Culture Virtually:
Schedule regular virtual team building activities and create opportunities for casual conversation. We host monthly virtual coffee chats where team members are randomly paired, and quarterly virtual team events. This helps build relationships beyond work tasks.

Set Clear Expectations and Goals:
Use OKRs (Objectives and Key Results) to align team members with company goals. Remote work requires clarity about expectations, deadlines, and success metrics. Weekly check-ins help keep everyone aligned without micromanaging.

Please discuss 3-4 essential digital tools for remote team productivity and how to use them effectively:

Project Management Software (Wrike/Asana):
Centralize all project information in one place. Create templates for recurring tasks, set up automation for routine processes, and use dashboards for visibility across teams. This reduces time spent in status update meetings by 50%.

Async Video Tools (Loom):
Record screen shares and video updates for training, feedback, and project walkthroughs. This respects different time zones and work schedules while maintaining personal connection that text alone can't provide.

Document Collaboration (Google Workspace/Notion):
Create a single source of truth for all company knowledge. Implement clear naming conventions and folder structures. This reduces time spent searching for information and ensures everyone has access to the latest versions.

Time Zone Management (World Clock/Calendly):
Be mindful of team members across time zones. Schedule meetings during overlapping hours and rotate meeting times if necessary to share the burden. Use async communication when possible to respect work-life boundaries.

What advice would you give about maintaining work-life balance in remote settings?

Encourage team members to set clear boundaries - designated workspace, consistent work hours, and actually taking breaks and vacation time. Lead by example by not sending messages outside work hours. We've implemented a "right to disconnect" policy where employees aren't expected to respond to non-urgent communications outside their scheduled hours. This has significantly reduced burnout and improved overall team satisfaction.
------------------------------------------------
Query: Remote Work and Team Productivity
Outlet: Forbes
Deadline: Wednesday, October 23rd at 2:00 PM EST
------------------------------------------------
Excited to hear your insights on this!

Best regards,
Catherine`,
        },
      ],
    };
  }

  // Remove note text from "Customer Experience Optimization" queries in inbox statuses (preserve dateWriting)
  if (
    query.title === 'Customer Experience Optimization' &&
    ['draft', 'awaiting', 'claimed', 'clientApproved', 'needsFollowUp', 'clientNeedsEdits'].includes(query.status)
  ) {
    try {
      const parsed = JSON.parse(query.notes);
      return { ...query, notes: JSON.stringify({ ...parsed, notes: '' }) };
    } catch {
      return { ...query, notes: '' };
    }
  }

  return query;
});

// Create DEMO_QUERY_DETAILS from the queries
export const DEMO_QUERY_DETAILS = DEMO_QUERIES.reduce((acc, query) => {
  acc[query.id] = query;
  return acc;
}, {});
